<template>
    <div class="d-flex justify-center">
        <v-divider vertical v-if="leftDivider"></v-divider>
        <div class="text-center mx-10">
            <router-link
                class="no-decoration"
                v-if="routerLink"
                :to="routerLink"
            >
                <v-avatar
                    class="display-1 white--text mb-2"
                    size="80"
                    v-bind:class="color"
                >
                    {{ this.value }}
                </v-avatar>
            </router-link>
            <v-avatar
                class="display-1 white--text mb-2"
                size="80"
                v-bind:class="color"
                v-if="!routerLink"
            >
                {{ this.value }}
            </v-avatar>
            <div class="blue-grey--text text--darken-2">
                {{ this.label }}
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Number,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        leftDivider: {
            type: Boolean,
            default: () => false,
        },
        color: {
            type: String,
            default: () => 'green',
        },
        routerLink: {
            type: Object,
            default: () => null,
        },
    },
}
</script>
